import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { Logo, PaddedContainer } from './styles';
import SiteMapDesktop from './site-map-desktop';
import SiteMapMobile from './site-map-mobile';

const Container = styled(PaddedContainer)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  ${props => (props.theme.isMobile ? `
    flex-direction: column;
    width: 100%;
    margin: 0;
    padding: 50px 20px;
    background-color: ${props.theme.secondaryColorLight};
  ` : `
    margin-top: 135px;
    margin-bottom: 136px;
  `)};

  ${props => ((!props.theme.isMobile && props.slim) && `
    max-width: unset;
    width: unset;
    justify-content: space-between;
  `)};
`;

export default function SiteMap({ slim }) {
  const {
    sitemapLogo, isUserSignedIn, isMobile, categoriesData, seriesData,
  } = React.useContext(ThemeContext);
  const [categories, setCategories] = React.useState([]);
  const [series, setSeries] = React.useState([]);
  const latestLink = isUserSignedIn ? '/feeds/latest' : '/';
  const siteMap = [
    {
      name: 'livewire',
      url: latestLink,
      sections: [
        { name: 'Latest', url: latestLink },
        { name: 'Trending', url: '/feeds/trending' },
        { name: 'Contributors', url: '/contributors' },
      ],
    },
    ...((slim && !isMobile) ? [] : [
      { name: 'categories', sections: categories },
      { name: 'series', sections: series },
    ]),
    {
      name: 'features',
      url: '/company/features',
      sections: [
        { name: 'Trending on Livewire', url: '/company/features#trending' },
        { name: 'Follow Contributors', url: '/company/features#follow' },
        { name: 'Wrap-Up Emails', url: '/company/features#wrapup' },
        { name: 'Send Enquiries', url: '/company/features#enquiries' },
      ],
    }, {
      name: 'solutions',
      url: '/company/solutions',
      sections: [
        { name: 'Why Livewire', url: '/company/solutions#why' },
        { name: 'Solutions', url: '/company/solutions#solutions' },
        { name: 'Testimonials', url: '/company/solutions#testimonial' },
        { name: 'Get in touch', url: '/company/solutions#get_in_touch' },
      ],
    }, {
      name: 'our story',
      url: '/company/our_story',
      sections: [
        { name: 'Values', url: '/company/our_story#values' },
        { name: 'Our Story', url: '/company/our_story#story' },
        { name: 'Careers', url: 'https://careers.smartrecruiters.com/LivewireMarkets' },
        { name: 'Contact Us', url: '/company/our_story#contact_us' },
      ],
    },
  ];

  React.useEffect(() => {
    const data = _.get(categoriesData, 'categories');
    if (_.get(data, 'length')) {
      setCategories(data);
    }
  }, [categoriesData]);

  React.useEffect(() => {
    const data = _.get(seriesData, 'series');
    if (_.get(data, 'length')) {
      setSeries(_.map(data, datum => ({ ...datum, name: datum.title })));
    }
  }, [seriesData]);

  return (
    <Container slim={!!slim}>
      <a href={latestLink}>
        <Logo src={sitemapLogo} />
      </a>
      {
        isMobile
          ? <SiteMapMobile siteMap={siteMap} />
          : <SiteMapDesktop siteMap={siteMap} />
      }
    </Container>
  );
}

SiteMap.propTypes = {
  slim: PropTypes.bool,
};

SiteMap.defaultProps = {
  slim: false,
};
